// Components==============
import { faFlask } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import './TestButton.module.scss';
// @ts-ignore
import packageJson from '../../../../../package.json';
// =========================

export default function TestButton() {
    return (
        <div styleName="test">
            <Link to="test-pagina">
                <FontAwesomeIcon icon={faFlask} />
                {packageJson.version}
            </Link>
        </div>
    );
}
